export default d => {
  return d instanceof Date && !isNaN(d);
};
